import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  ContentPopperProps,
  FONT_WEIGHTS,
  mobileOnlyLinaria,
  SPACING,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {BnplSlotName} from './constants';
import {InvoiceProcessFlow} from './InvoiceProcessFlow';
import {HowDoesItWorkModal, usePopover} from './LearnMorePopover';

interface SelectedInvoicePaymentSlotProps {
  BnplInfoLayoutComponent: ContentPopperProps['LayoutComponent'];
}

export const SelectedInvoicePaymentSlot = ({
  BnplInfoLayoutComponent,
}: SelectedInvoicePaymentSlotProps) => {
  const {t} = useTranslation();
  const howDoesItWork = usePopover('bnpl-how-does-it-work');

  return (
    <SlotWrapper
      slot={BnplSlotName.optionSelectedUnderLabel}
      data-testid="selected-invoice-payment-slot"
    >
      <ContentWrapper>
        <DefaultInfo>
          <Description
            dangerouslySetInnerHTML={{
              __html: t(
                "<b>Try first, pay later.</b> Take up to 14 days to pay after we've shipped your order. We'll send you a <b>payment link</b> — you decide how you'd like to pay.",
              ),
            }}
          />

          <InvoiceProcessFlow />

          <LinkButton
            onClick={howDoesItWork.openPopover}
            data-testid="how-does-it-work-link"
            type="button"
          >
            {t('How does it work?')}
          </LinkButton>
        </DefaultInfo>
      </ContentWrapper>

      <HowDoesItWorkModal
        open={howDoesItWork.isOpen}
        onClose={howDoesItWork.closePopover}
        LayoutComponent={BnplInfoLayoutComponent}
      />
    </SlotWrapper>
  );
};

const SlotWrapper = styled.div`
  margin: ${SPACING['Y.Xl']} 0;
  width: 100%;
  ${mobileOnlyLinaria(`margin-top: 13px;`)}
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

const DefaultInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Description = styled.p`
  font-size: 13px;
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: 1.2;
  color: ${COLORS.Black};
  letter-spacing: -0.26px;
  margin: 0;
`;

const LinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 13px;
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  line-height: 1.2;
  color: ${COLORS.Black};
  letter-spacing: -0.26px;
  text-decoration: underline;
  text-align: left;
`;
